export const urls = {
  loggedinUser: {
    method: "POST",
    url: "/loggedin/user/details"
  }
};
